// TODO: Мнения экспертов
export default [
  { key: 'topic_type', value: 'article', title: 'Статьи' },
  { key: 'topic_type', value: 'news', title: 'Новости' },
  { key: 'tag', value: 'mneniye-ekspertov', title: 'Мнения экспертов' },
];
